export const urlify = (text?: string | null) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text?.replace(urlRegex, (url) => {
    return `<a href="${url}">${text?.replace(url, "")}</a>`;
  });
};
